import { defineComponent as _defineComponent } from 'vue'
import {
  ButtonPrimary,
  ButtonSecondary,
  ButtonContainer,
  Modal,
  BaseText,
  Heading,
  BaseIcon
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Portal } from '@/modules/common/components/Portal';
import { logoutImpersonate } from '@/modules/common/services/partner';
import { getURLParams } from '@/modules/wallet-builder/src/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImpersonateEducationalModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ['close', 'continue'],
  setup(__props: any, { emit }) {





// Icon colors from Nebraska Design System
const STEP_ICON_COLOR = NebraskaColors.statusPositive;
const INFO_ICON_COLOR = NebraskaColors.statusInfo;

const steps = [
  {
    icon: 'EE0100',
    title: 'Acesse o Catálogo',
    description: 'Lá você encontra todos os ativos disponíveis.'
  },
  {
    icon: 'AA0040',
    title: 'Selecione o cliente',
    description: 'Encontre o cliente que deseja enviar a sugestão.'
  },
  {
    icon: 'EF0071',
    title: 'Finalize a sugestão',
    description: 'Ela será enviada automaticamente para aceite do seu cliente.'
  },
  {
    icon: 'DA0012',
    title: 'Acompanhe a Ordem',
    description: 'Você poderá ver tudo na aba Acompanhamento.'
  }
];

function handleClose() {
  emit('close');
}

function handleContinueAsClient() {
  emit('continue');
}

function handleGoToFlow() {
  const urlParams = getURLParams(true);

  if (urlParams?.backTo) {
    window.location.replace(urlParams.backTo);
    return;
  }

  logoutImpersonate();
}

return { __sfc: true,emit, STEP_ICON_COLOR, INFO_ICON_COLOR, steps, handleClose, handleContinueAsClient, handleGoToFlow, ButtonPrimary, ButtonSecondary, ButtonContainer, Modal, BaseText, Heading, BaseIcon, NebraskaColors, Portal }
}

})